import { svg } from 'lit';

export const chevronBackIcon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.4697 5.46966C13.7626 5.17677 14.2374 5.17677 14.5303 5.46966C14.7966 5.73593 14.8208 6.15259 14.603 6.4462L14.5303 6.53032L9.06101 12L14.5303 17.4697C14.7966 17.7359 14.8208 18.1526 14.603 18.4462L14.5303 18.5303C14.2641 18.7966 13.8474 18.8208 13.5538 18.6029L13.4697 18.5303L7.46968 12.5303C7.20342 12.2641 7.17921 11.8474 7.39707 11.5538L7.46968 11.4697L13.4697 5.46966Z" fill="#786E5C"/>
</svg>
`;
